import FileStorageMain from './FileStorageMain';
export default FileStorageMain;
